import Button from "@components/Button";
import Link from "@components/Link";
import { useTranslationContext } from "@providers/TranslationProvider";
import cx from "classnames";
import Item from "./Item";
import styles from "./OurOffers.module.scss";
import { usePageContext } from "@providers/PageProvider";
import helper from "@utils/helper";
import get from "lodash/get";
import map from "lodash/map";
import OfferService from "@services/OfferService";
import usePromise from "@hooks/usePromise";
export default function OurOffers() {
  const { i18n } = useTranslationContext();
  const { pageData, hotel } = usePageContext();
  const [_offers] = usePromise(async () => {
    const resOffer = await OfferService.find({
      filters: {
        hotel: {
          slug: {
            $eq: hotel,
          },
        },
      },
      populate: ["thumbnail", "category"],
      page: 1,
      pageSize: 2,
      locale: i18n.language,
    });
    return get(resOffer, "data", []);
  });
  const offerData = helper.formatOffers(pageData);

  const offers = map(_offers, helper.formatOfferItem);
  const readMoreButton = get(offerData, "readMoreButton");
  return (
    <div data-scroll-section className={cx(styles.section, "inner-large")}>
      <div className={cx(styles.boxTitle)}>
        <div className={cx(styles.title)}>{get(offerData, "title")}</div>
        <Link
          href={get(readMoreButton, "href") || "#"}
          className={cx(styles.btn)}
        >
          <Button
            type="icon"
            className={cx("uppercase button")}
            label={
              <div className={cx(styles.labelBtn)}>
                {get(readMoreButton, "label")}
              </div>
            }
            suffix="shape-arrow"
          />
        </Link>
      </div>
      <div className={cx(styles.wrapperItems)}>
        {map(offers, (item, index) => (
          <Item key={index} data={item} />
        ))}
      </div>
    </div>
  );
}
